import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Menu, Layout, Icon } from 'antd'
import store from 'store'
import { Scrollbars } from 'react-custom-scrollbars'
import _ from 'lodash'
import styles from './style.module.scss'
import { connect } from '../../../../redux/index'

const { Sider } = Layout
const { SubMenu, Divider } = Menu

const mapStateToProps = ({ menu, settings, clinic, user }) => ({
  menuData: menu.menuLeftData,
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isSettingsOpen: settings.isSettingsOpen,
  isLightTheme: settings.isLightTheme,
  isMobileMenuOpen: settings.isMobileMenuOpen,
  clinic,
  user,
})

@withRouter
@connect(mapStateToProps)
class MenuLeft extends React.Component {
  state = {
    selectedKeys: store.get('app.menu.selectedKeys') || [],
    openedKeys: store.get('app.menu.openedKeys') || [],
  }

  componentDidMount() {
    this.setSelectedKeys(this.props)
  }

  componentWillReceiveProps = async (newProps) => {
    if (newProps.isMenuCollapsed && !newProps.isMobileView) {
      this.setState({
        openedKeys: [],
      })
    }
    this.setSelectedKeys(newProps)
  }

  setSelectedKeys = (props) => {
    const { menuData } = this.props
    const flattenItems = (items, key) =>
      items.reduce((flattenedItems, item) => {
        flattenedItems.push(item)
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key))
        }
        return flattenedItems
      }, [])
    const selectedItem = _.find(flattenItems(menuData, 'children'), [
      'url',
      props.location.pathname,
    ])
    this.setState({
      selectedKeys: selectedItem ? [selectedItem.key] : [],
    })
  }

  onCollapse = (value, type) => {
    const { dispatch, isMenuCollapsed } = this.props
    if (type === 'responsive' && isMenuCollapsed) {
      return
    }

    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    })

    this.setState({
      openedKeys: [],
    })
  }

  onOpenChange = (openedKeys) => {
    store.set('app.menu.openedKeys', openedKeys)
    this.setState({
      openedKeys,
    })
  }

  handleClick = (e) => {
    const { dispatch, isSettingsOpen, isMobileView, isMobileMenuOpen } = this.props
    store.set('app.menu.selectedKeys', [e.key])
    // close menu if mobile menu opened
    if (isMobileView) {
      setTimeout(() => {
        dispatch({
          type: 'settings/CHANGE_SETTING',
          payload: {
            setting: 'isMobileMenuOpen',
            value: !isMobileMenuOpen,
          },
        })
      }, 500)
    }
    // custom action on settings menu item
    if (e.key === 'settings') {
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isSettingsOpen',
          value: !isSettingsOpen,
        },
      })
      return
    }
    this.setState({
      selectedKeys: [e.key],
      // openKeys: e.keyPath,
    })
  }

  generateMenuItems = () => {
    const { menuData = [] } = this.props
    const generateItem = (item) => {
      const { key, title, url, icon, disabled, iconType = 'antd', testid } = item
      if (item.divider) {
        return <Divider key={Math.random()} />
      }
      if (item.url) {
        return (
          <Menu.Item key={key} disabled={disabled}>
            {item.target ? (
              <a
                data-testid={testid}
                id={testid}
                href={url}
                target={item.target}
                rel="noopener noreferrer"
              >
                {icon && icon !== 'user' && icon !== 'packages' && iconType === 'antd' && (
                  <Icon
                    type={icon}
                    theme={icon !== 'user' && 'filled'}
                    className={` ${styles.icon}`}
                  >
                    {' '}
                  </Icon>
                )}
                {icon && iconType === 'fontAwesome' && <i className={icon} />}
                {icon && icon === 'user' && <i className={` icmn icmn-users ${styles.icon}`} />}
                {icon && icon === 'packages' && (
                  <i
                    className={`fa fa-bed ${styles.icon}`}
                    style={{ fontSize: '16px' }}
                    aria-hidden="true"
                  />
                )}
                {icon && icon === 'fa fa-users' && (
                  <i
                    className={`fa fa-users ${styles.icon}`}
                    style={{ fontSize: '16px' }}
                    aria-hidden="true"
                  />
                )}
                <span className={styles.title}>{title}</span>
              </a>
            ) : (
              <Link data-testid={testid} id={testid} to={url}>
                {iconType === 'svg' && (
                  <i aria-label="icon: user" className={`${styles.icon} anticon`}>
                    {item.svg}
                  </i>
                )}
                {icon && icon !== 'packages' && iconType === 'antd' && (
                  <Icon
                    viewBox="0 0 1024 1024"
                    type={icon}
                    // theme={icon !== 'user' && 'filled'}
                    theme="outlined"
                    className={` ${styles.icon}`}
                  />
                )}

                {icon && iconType === 'fontAwesome' && (
                  <i className={`${icon} ${styles.icon}`} style={{ fontSize: '16px' }} />
                )}
                {/* {icon && icon === 'user' && <i className={` icmn icmn-users ${styles.icon}`} />} */}
                {icon && icon === 'packages' && (
                  <i
                    className={`fa fa-bed ${styles.icon}`}
                    style={{ fontSize: '16px' }}
                    aria-hidden="true"
                  />
                )}
                {/* {icon && icon === 'fa fa-users' && (
                  <i
                    className={`fa fa-users ${styles.icon}`}
                    style={{ fontSize: '16px' }}
                    aria-hidden="true"
                  />
                )} */}
                <span className={styles.title}>{title}</span>
              </Link>
            )}
          </Menu.Item>
        )
      }
      return (
        <Menu.Item key={key} disabled={disabled}>
          <span className={styles.title}>{title}</span>
          {icon && <i className={`${icon} ${styles.icon}`} />}
        </Menu.Item>
      )
    }

    const generateSubmenu = (items) =>
      items.map((menuItem) => {
        if (menuItem.children) {
          const subMenuTitle = (
            <span key={menuItem.key}>
              <span className={styles.title}>{menuItem.title}</span>
              {menuItem.icon && <span className={`${menuItem.icon} ${styles.icon}`} />}
            </span>
          )

          return (
            <SubMenu title={subMenuTitle} key={menuItem.key}>
              {generateSubmenu(menuItem.children)}
            </SubMenu>
          )
        }
        return generateItem(menuItem)
      })

    return menuData.map((menuItem) => {
      if (menuItem.children) {
        const subMenuTitle = (
          <span key={menuItem.key}>
            <span className={styles.title}>{menuItem.title}</span>
            {menuItem.icon && <span className={`${menuItem.icon} ${styles.icon}`} />}
          </span>
        )
        return (
          <SubMenu
            className={menuItem.display === false ? 'd-none' : ''}
            title={subMenuTitle}
            key={menuItem.key}
          >
            {generateSubmenu(menuItem.children)}
          </SubMenu>
        )
      }
      return generateItem(menuItem)
    })
  }

  render() {
    const { selectedKeys, openedKeys } = this.state
    const { isMobileView, /* isMenuCollapsed, */ isLightTheme } = this.props
    const menuSettings = isMobileView
      ? {
          width: 150,
          collapsible: false,
          collapsed: false,
          onCollapse: this.onCollapse,
        }
      : {
          width: 150,
          collapsible: true,
          collapsed: true,
          // collapsed: true,
          onCollapse: this.onCollapse,
          // breakpoint: 'lg',
        }

    const menu = this.generateMenuItems()
    return (
      <Sider
        {...menuSettings}
        style={{ zIndex: 6 }}
        className={isLightTheme ? `${styles.menu} ${styles.light}` : styles.menu}
      >
        <div className={styles.logo} style={{ backgroundColor: '#ffffff' }}>
          <div className={styles.logoContainer} style={{ borderBottom: '1px solid #e4e9f0' }}>
            <Link to="/">
              <img src="resources/images/logo-icon.png" className="img-fluid" alt="" />
            </Link>
          </div>
        </div>
        <Scrollbars
          className={isMobileView ? styles.scrollbarMobile : styles.scrollbarDesktop}
          autoHide
          style={{ overflow: 'hidden' }}
        >
          <Menu
            theme={isLightTheme ? 'light' : 'dark'}
            onClick={this.handleClick}
            selectedKeys={selectedKeys}
            openKeys={openedKeys}
            onOpenChange={this.onOpenChange}
            mode="inline"
            className={styles.navigation}
          >
            {menu}
          </Menu>
        </Scrollbars>
      </Sider>
    )
  }
}

export default MenuLeft
